import * as React from 'react';
import { routeNode, IRouteNodeProps } from 'react-mobx-router5';

// Constants
import { ROUTE_NAMES } from '../../constants/routes';

// Views
import Login from '../Login';
import SignUp from '../SignUp';
import Forgot from '../Forgot';
import Reset from '../Reset';
import App from '../App';

// Component
export interface IProps extends IRouteNodeProps {}

class Router extends React.Component<IProps, {}> {
  render() {
    if (!this.props.route) {
      return <h1>Page not found</h1>;
    }

    const segment = this.props.route.name.split('.')[0];
    switch (segment) {
      case ROUTE_NAMES.LOGIN:
        return <Login />;
      case ROUTE_NAMES.SIGNUP:
        return <SignUp />;
      case ROUTE_NAMES.FORGOT:
        return <Forgot />;
      case ROUTE_NAMES.RESET:
        return (
          <Reset
            query={{
              secret: this.props.route.params.secret,
              id: this.props.route.params.id
            }}
          />
        );
      case ROUTE_NAMES.APP:
        return <App />;
      default:
        return <h1>Something went wrong...</h1>;
    }
  }
}

export default routeNode('')(Router);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Root/Router.tsx